import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-chat-whatsapp',
  templateUrl: './chat-whatsapp.component.html',
  styleUrls: ['./chat-whatsapp.component.css']
})
export class ChatWhatsappComponent implements OnInit, OnDestroy {
  whatsappUrl: string = '';
  private routerSubscription: Subscription;

  constructor(private router: Router) { }

  ngOnInit() {
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.setWhatsappUrl(event.urlAfterRedirects);
      }
    });
  }

  setWhatsappUrl(currentRoute: string) {
    const whatsappNumber = currentRoute.includes('/pasate') ? '573195005050' : '573192510001';
    this.whatsappUrl = `https://wa.me/${whatsappNumber}`;
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
